document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.swipe_custom_slider');

    sliders.forEach((slider) => {
     
        const centerMode = slider.getAttribute('swipe-center-mode') === 'true';
        const autoplay = slider.getAttribute('autoplay') === 'true';
        const slidesPerRow = parseFloat(slider.getAttribute('swiper-per-view')) || 1;

       
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            centeredSlides: false,
            direction: 'horizontal',
            loop: true,
            autoplay: autoplay,
            speed:2000,
            breakpoints: {
                1024: {
                    slidesPerView: slidesPerRow,
                    spaceBetween: 30,
                    centeredSlides: centerMode
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    centeredSlides: centerMode
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            }
        });
    });
});
